import { CsvColumn } from './toCsv'

// Filters with the same column definitions used for CSV export, so the rows on
// screen and the rows in the downloaded file always agree.
export const filterByColumns = <T>(
  columns: CsvColumn<T>[],
  rows: T[],
  // Search clears itself by passing undefined, so this must tolerate it.
  term?: string,
) => {
  const needle = (term ?? '').trim().toLowerCase()
  if (!needle) return rows

  return rows.filter((row) =>
    columns.some((column) => {
      const value = column.value(row)
      if (value === null || value === undefined) return false
      return String(value).toLowerCase().includes(needle)
    }),
  )
}
